module.exports = __webpack_public_path__ + "img/charge-management.96b70d44.png";